export const markScales = [
  { value: 0, label: '0' },
  { value: 100, label: '100' },
]
